import { createSlice } from '@reduxjs/toolkit';
import { IOrderCounter } from '../../../../dto';
import { setOrderCounters } from '../actions';
import { MN_ORDER_COUNTERS, TYPE_LIST } from '../../../../common';

export interface OrderCountersState {
  data: IOrderCounter[];
  loading: boolean;
  error: string | null;
}

const initialState: OrderCountersState = {
  data: [],
  loading: false,
  error: null,
};

export const orderCountersSlice = createSlice({
  name: `${MN_ORDER_COUNTERS}/${TYPE_LIST}`,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setOrderCounters, (state, { payload }) => {
      state.data = payload;
    });
  },
});
